import { FontColorEnum, FontSizeEnum, FontWeightEnum, Typography } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { TProgramBroadcast } from '@/features/broadcast-schedule/types';
import { TSegment } from '@/features/segments/types';
import { formatDate } from '@/helpers/format-date';

import { BroadcastScheduleProgramGlobalViewBodyVideoPlayer } from '../BroadcastScheduleProgramGlobalViewBodyVideoPlayer';

type TBroadcastScheduleProgramGlobalViewBodyProgramCardProps = {
  programBroadcast?: TProgramBroadcast;
  segments: TSegment[];
};

export function BroadcastScheduleProgramGlobalViewBodyProgramCard({
  programBroadcast,
  segments,
}: TBroadcastScheduleProgramGlobalViewBodyProgramCardProps) {
  const { t } = useTranslation();

  if (!programBroadcast) return null;

  return (
    <div className="flex h-full flex-col gap-3 overflow-y-auto rounded border border-gray-200 bg-white p-4">
      <Typography
        fontSize={FontSizeEnum.Lg}
        weight={FontWeightEnum.Semibold}
        color={FontColorEnum.ActivePrimary}
      >
        {programBroadcast.name}
      </Typography>
      <Typography
        fontSize={FontSizeEnum.Md}
        weight={FontWeightEnum.Semibold}
        color={FontColorEnum.ActivePrimary}
      >
        {programBroadcast.description}
      </Typography>

      <div className="flex items-end justify-between">
        <div className="flex flex-col gap-1">
          <Typography fontSize={FontSizeEnum.Sm} color={FontColorEnum.Default}>
            {t('Inicio')}: {formatDate(programBroadcast.start_datetime).datePart}{' '}
            {formatDate(programBroadcast.start_datetime).timePart}
          </Typography>
          <Typography fontSize={FontSizeEnum.Sm} color={FontColorEnum.Default}>
            {t('Fin')}: {formatDate(programBroadcast.end_datetime).datePart}{' '}
            {formatDate(programBroadcast.end_datetime).timePart}
          </Typography>
        </div>

        <Typography fontSize={FontSizeEnum.Sm} color={FontColorEnum.Default}>
          {segments.length} {t('Franjas')}
        </Typography>
      </div>

      <div className="min-h-[200px] flex-1">
        <BroadcastScheduleProgramGlobalViewBodyVideoPlayer />
      </div>
    </div>
  );
}
